<template>
    <li class="nav-item dropdown" @click="toggleDropDown" v-click-outside="closeDropDown">
        <a class="nav-link"
            href="#"
            role="button"
            data-toggle="dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span :class="`flag-icon flag-icon-${iso}`"></span>
        </a>
        <div class="dropdown-menu"
            :class="[{show: isOpen}, {'dropdown-menu-right': !mobile}]"
        >
            <div v-for="language in languages" :key="language.id">
                <a href="#!" class="dropdown-item" @click="changeLanguage(language.iso)">
                    <i :class="`nch--flag-icon flag-icon flag-icon-${
                        language.iso === 'en' ? 'us' :
                        language.iso === 'pt-BR' ? 'br' :
                        language.iso
                        }`"></i>
                    <span>{{language.name}}</span>
                </a>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'Language',
    data() {
        return {
            isOpen: false,
            iso: '',
        };
    },
    props: {
        languages: {
            type: Array,
        },
        mobile: {
            type: Boolean,
        },
    },
    computed: {
        direction() {
            return !this.$store.getters.NAVBAR_POSITION;
        },
    },
    methods: {
        toggleDropDown() {
            this.isOpen = !this.isOpen;
        },
        closeDropDown() {
            this.isOpen = false;
            this.$emit('change', false);
        },
        changeLanguage(iso) {
            if (iso === this.iso) false;

            window.axios.get(`/change-language/${iso}`)
                .then((res) => {
                    setTimeout(() => {
                        if (iso === 'us') {
                            localStorage.setItem('lang', 'en');
                        } else {
                            localStorage.setItem('lang', iso);
                        }
                        location.reload();
                        this.iso = iso;
                    }, 150);
                })
                .catch(err => console.log(err));
        },
        checkLanguage() {
            this.iso = localStorage.getItem('lang') === 'en' ? 'us' : localStorage.getItem('lang');
            this.iso = this.iso === 'pt-BR' ? 'br' : this.iso;
        },
        setDefaultLanguage() {
            const language = this.languages.find(language => language.iso === localStorage.getItem('lang'));
            this.$store.commit('SET_DEFAULT_LANGUAGE', language);
        },
    },
    mounted() {
        this.checkLanguage();
        this.setDefaultLanguage();
    },
};
</script>

<style>
    .nch--flag-icon {
        vertical-align: 0 !important;
    }
</style>
